import { useEffect, useState } from 'react'
import styles from './account-settings-style.module.css'
import { ACCOUNT_LOADING, updateAccountData, useAuth, ACCOUNT_AREAS, ACCOUNT_TYPES, requestAccountTypeAndAreaChange, useHasPendingAccountTypeAreaRequest, changePassword, getMessagingToken, subscribeToMessagingTopics, unsubscribeFromAllMessagingTopics } from '../firebase/firebase'
import { Timestamp } from 'firebase/firestore';
import ProfilePicEditor from './ProfilePicEditor';
import { getNotificationsEnabled, getTopicSubscriptions, storeNotificationsEnabled, storeTopicSubscriptions, } from '../firebase/LocalStorage';

function AccountSettings({ setShowNavBar }) {
        
    const [, accountData] = useAuth();

    const [editedAccountData, updateEditedAccountData] = useEditedAccountData();
    const notifications = useEditedNotificationSubscriptions();

    const [resetFlag, flagReset] = useState(0);

    const [changeFlag0, setChangeFlag0] = useState(false);
    const [changeFlag1, setChangeFlag1] = useState(false);
    const [changeFlag2, setChangeFlag2] = useState(false);
    const [changeFlag3, setChangeFlag3] = useState(false);
    const [areYouSureVis, setAreYouSureVis] = useState(false);
    
    const [mouseCords, setMouseCords] = useState({x: 0, y: 0});
    const [mouseDown, setMouseDown] = useState(false);

    useEffect(() => setShowNavBar(true));
    
    const updateChangeFlags = (flagCode, flag) => {
        if(flagCode === 0) setChangeFlag0(flag);
        else if(flagCode === 1) setChangeFlag1(flag);
        else if(flagCode === 2) setChangeFlag2(flag);
        else if(flagCode === 3) setChangeFlag3(flag);
    }

    const updateAccount = (override) => {
        if(editedAccountData.email !== accountData?.email && !override)
            setAreYouSureVis(true);
        else {
            setAreYouSureVis(false);
            updateAccountData(editedAccountData);

            storeNotificationsEnabled(notifications.enabled);
            storeTopicSubscriptions(notifications.subscriptions);

            if(notifications.enabled)
                subscribeToMessagingTopics(notifications.token, notifications.subscriptions);
            else
                unsubscribeFromAllMessagingTopics(notifications.token);

            notifications.flagSaved();
        }    
    };

    const undoChanges = () => { flagReset(resetFlag + 1) }

    return (
        <div key={resetFlag} id={styles.container} onMouseMove={(e) => {setMouseCords({x: e.pageX, y: e.pageY})}}
        onMouseDown={() => {setMouseDown(true)}}
        onMouseUp={() => {setMouseDown(false)}}>
            <h1>Account Settings</h1>
            <div id={styles.settings}>
                <PersonalInfoTab accountData={accountData} updateChangeFlags={updateChangeFlags} resetFlag={resetFlag} updateEditedAccountData={updateEditedAccountData}/>
                <AccountDetailsTab accountData={accountData} updateChangeFlags={updateChangeFlags} resetFlag={resetFlag} updateEditedAccountData={updateEditedAccountData}/>
                <NotificationsTab accountData={accountData} updateChangeFlags={updateChangeFlags} resetFlag={resetFlag} notifications={notifications}/>
                <ProfilePictureTab accountData={accountData} updateChangeFlags={updateChangeFlags} resetFlag={resetFlag}
                                    updateEditedAccountData={updateEditedAccountData} mouseDown={mouseDown} mouseCords={mouseCords}/>
            </div> 
            <div className={(changeFlag0 || changeFlag1 || changeFlag2 || changeFlag3) ? styles.bottom_bar : `${styles.bottom_bar} ${styles.hidden}`}>
                <h1>Your account settings have unsaved changes</h1>
                <button id={styles.save} onClick={() => updateAccount(false)}>Save</button>
                <button onClick={() => undoChanges()}>Undo</button>
            </div>
            <div id={styles.popup} className={areYouSureVis ? '' : styles.hidden}>
                <h1>Are you sure you want to change you email address?</h1>
                <button onClick={() => updateAccount(true)}>Yes</button>
                <button onClick={() => setAreYouSureVis(false)}>No</button>
            </div>
        </div>
    )
}

function PersonalInfoTab({accountData, updateChangeFlags, resetFlag, updateEditedAccountData}) {
    const [firstName, setFirstName] = useState(accountData?.first_name);
    const [lastName, setLastName] = useState(accountData?.last_name);
    const [phoneNumber, setPhoneNumber] = useState(accountData?.phone_number);
    const [birthdate, setBirthdate] = useState('');

    useEffect(() => {
        setFirstName(accountData?.first_name);
        setLastName(accountData?.last_name);
        setPhoneNumber(accountData?.phone_number);
        setBirthdate(convertBirthDateToString(accountData?.birthday));
        
    }, [accountData, resetFlag]);

    const phoneKeydownListener = (evt) => {
        if (!(evt.ctrlKey || evt.key.length > 1 || /[0-9.]/.test(evt.key)))
            evt.preventDefault();
    }
    const phoneKeyUpListener = (evt) => {
        const digits = evt.target.value.replace(/\D/g,'').substring(0,10);
        const areaCode = digits.substring(0,3);
        const prefix = digits.substring(3,6);
        const suffix = digits.substring(6,10);

        if(digits.length > 6) {evt.target.value = `(${areaCode}) ${prefix}-${suffix}`;}
        else if(digits.length > 3) {evt.target.value = `(${areaCode}) ${prefix}`;}
        else if(digits.length > 0) {evt.target.value = `(${areaCode}`;}
    }

    useEffect(() => {
        let changesExist = false;

        if(accountData === undefined || accountData === null || accountData === ACCOUNT_LOADING)
            return;

        if(firstName !== accountData.first_name)
            changesExist = true;
        else if(lastName !== accountData.last_name)
            changesExist = true;
        else if(phoneNumber !== accountData.phone_number)
            changesExist = true;
        else if(birthdate !== convertBirthDateToString(accountData.birthday))
            changesExist = true;

        updateChangeFlags(0x01, changesExist);
        updateEditedAccountData({first_name: firstName, last_name: lastName, phone_number: phoneNumber, birthday: parseBirthdayFromString(birthdate)});
    }, [firstName, lastName, phoneNumber, birthdate, accountData])

    return (
        <div id={styles.personal} className={styles.category}>
            <h1>Personal Info</h1>
            <label htmlFor='first-name'>First Name</label>
            <input className='data-input' id='first-name' defaultValue={accountData?.first_name} onChange={(e) => setFirstName(e.target.value)} autoComplete='given-name'/>
            <label htmlFor='last-name'>Last Name</label>
            <input className='data-input' id='last-name' defaultValue={accountData?.last_name} onChange={(e) => setLastName(e.target.value)} autoComplete='family-name'/>
            <label htmlFor='phone'>Phone Number</label>
            <input className='data-input' type="tel" id='phone' autoComplete="tel-national" 
                onChange={(e) => setPhoneNumber(e.target.value)}
                onKeyDown={(e) => phoneKeydownListener(e)} 
                onKeyUp={(e) => phoneKeyUpListener(e)} 
                placeholder='(123) 456-7890' defaultValue={accountData?.phone_number}/>
            
            <label htmlFor='birthdate'>Birthdate</label>
            <input className='data-input' type="date" id='birthdate' defaultValue={convertBirthDateToString(accountData?.birthday)} onChange={(e) => setBirthdate(e.target.value)} autoComplete='bday-day'/>

        </div>
    )
}
function AccountDetailsTab({accountData, updateChangeFlags, resetFlag, updateEditedAccountData}) {
    const passwordEye = '/images/password-eye.png';
    const passwordEyeSlash = '/images/password-eye-slash.png';

    const [email, setEmail] = useState(accountData?.email);

    const [typeAndAreaVisibility, setTypeAndAreaVisibility] = useState(false);
    const [accountType, setAccountType] = useState('')
    const [accountArea, setAccountArea] = useState('');
    const pendingRequest = useHasPendingAccountTypeAreaRequest();

    const [currentPasswordCorrect, setCurrentPasswordCorrect] = useState(true);
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [passwords, setPasswords] = useState(["", "", ""]);
    const [icon, setIcon] = useState(passwordEye);
    const [type, setType] = useState('password');

    useEffect(() => {
        setEmail(accountData?.email);
    }, [accountData, resetFlag]);

    useEffect(() => {
        updateChangeFlags(1, email !== accountData?.email); 
        updateEditedAccountData({email});           
    }, [email, accountData]);

    const cancelTypeAndArea = () => {
        setTypeAndAreaVisibility(false);
        setTimeout(() => {
            document.getElementById('type').selectedIndex = 0;
            document.getElementById('area').selectedIndex = 0;

            setAccountType('');
            setAccountArea('');
        }, 510);
    }
    const submitTypeAreaRequest = () => {
        if(accountType === '' && accountArea === '')
            cancelTypeAndArea();
       
        requestAccountTypeAndAreaChange(accountArea, accountType, accountData);
        cancelTypeAndArea();
    }
    const toggleTypeAreaVisibility = () => {
        if(typeAndAreaVisibility)
            cancelTypeAndArea();
        else
            setTypeAndAreaVisibility(true);
    }

    const handleToggle = () => {
        if (type==='password'){
           setIcon(passwordEyeSlash);
           setType('text')
        } else {
           setIcon(passwordEye)
           setType('password')
        }
    }
    const cancelPasswordChange = () => {
        setPasswordVisibility(false);
        setTimeout(() => {
            document.getElementById('old-password').value = '';
            document.getElementById('password').value = '';
            document.getElementById('password-again').value = '';

            setPasswords(['', '', ''])
            setCurrentPasswordCorrect(true);
        }, 510);
    }
    const submitPasswordChange = () => {
        if (passwords[1] === passwords[2] && passwords[1].length > 6) {
            changePassword(passwords[0], passwords[1], 
                () => {
                    setCurrentPasswordCorrect(false);
                },
                () => {
                    alert("Your password has been sucessfully changed.");
                    cancelPasswordChange();
                });            
        }        
    }
    const togglePasswordVisibility = () => {
        if (passwordVisibility)
            cancelPasswordChange();
        else
            setPasswordVisibility(true);
    }

    return (
        <div id={styles.account} className={styles.category}>
            <h1>Account Details</h1>
            <label htmlFor={styles.email}>Email</label>
            <input id={styles.email} className='data-input' type='email' defaultValue={accountData?.email} onChange={(e) => setEmail(e.target.value)} autoComplete='email'/>

            <p>{`Account Type: ${accountData?.account_type}`}</p>
            <p>{`Account Area: ${accountData?.account_area}`}</p>
            <p style={{fontStyle: 'italic', opacity: pendingRequest ? '1' : '0', transitionDuration: '0.25s', color: '#700000'}}>Pending Change Request</p>

            <button onClick={() => toggleTypeAreaVisibility()}>Request Change</button>

            <div id={styles.type_area} style={typeAndAreaVisibility ? {} : {height: '0px', paddingTop: 0, paddingBottom: 0}}>
                <label htmlFor="type">New Account Type</label>
                <select type="text" id="type" onChange={(e) => setAccountType(e.target.value)} defaultValue={''}>
                    <option value={''} disabled hidden key="no-change">-- No Change --</option>
                    {
                        ACCOUNT_TYPES.map(type => <option key={type}>{type}</option>)
                    }
                </select>

                <label htmlFor="area">New Account Area</label>
                <select type="text" id="area" onChange={(e) => setAccountArea(e.target.value)} defaultValue={''}>
                    <option value={''} disabled hidden key="no-change-2">-- No Change --</option>
                    {
                        ACCOUNT_AREAS[
                                (accountType === '') ?
                                    accountData?.account_type?.toLocaleLowerCase()?.split(' ')?.[0] :
                                    accountType.toLocaleLowerCase().split(' ')[0]
                            ]?.map(role => <option key={role}>{role}</option>)
                    }
                </select>
                <div>
                    <button onClick={() => submitTypeAreaRequest()}>Submit Request</button>
                    <button onClick={() => cancelTypeAndArea()}>Cancel</button>
                </div>                        
            </div>

            <button onClick={() => togglePasswordVisibility()}>Change Password</button>

            <div id={styles.password_change} style={passwordVisibility ? {} : {height: '0px', paddingTop: 0, paddingBottom: 0}}>
                <label htmlFor='old-password'>Current Password</label>
                <input type={type} id='old-password' className="ata-input" onChange={(e) => setPasswords([e.target.value, passwords[1], passwords[2]])} autoComplete='current-password'/>
                <span><img className={styles.eye} alt="View Password Eye" src={icon} onClick={handleToggle}/></span>
                <p style={{fontStyle: 'italic', color: '#770000', marginTop: '-8px', marginBottom: '8px', display: currentPasswordCorrect ? 'none' : 'block'}}>Current Password Incorrect</p>

                <label htmlFor='password'>New Password</label>
                <input type={type} id='password' className="ata-input" onChange={(e) => setPasswords([passwords[0], e.target.value, passwords[2]])} autoComplete='new-password'/>
                <span><img className={styles.eye} alt="View Password Eye" src={icon} onClick={handleToggle}/></span>

                <label htmlFor='password-again'>Retype New Password</label>
                <input type={type} id='password-again' className="ata-input" onChange={(e) => setPasswords([passwords[0], passwords[1], e.target.value])}  autoComplete='new-password'/>
                <span><img className={styles.eye} alt="View Password Eye" src={icon} onClick={handleToggle}/></span>

                <p style={{color: 'red', textAlign: 'center', visibility: (passwords[1] === passwords[2]) ? 'hidden' : 'visible'}}>Passwords do not match.</p>
                <p style={{color: 'red', textAlign: 'center', visibility: (passwords[1].length > 6 || passwords[1].length <  1) ? 'hidden' : 'visible'}}>Password must be more than 6 characters.</p>
            
                <div>
                    <button onClick={() => submitPasswordChange()}>Submit Request</button>
                    <button onClick={() => cancelPasswordChange()}>Cancel</button>
                </div> 
            </div>
        </div>
    )
}
function NotificationsTab({accountData, updateChangeFlags, resetFlag, notifications}) {
    useEffect(() => {
        if(Notification.permission === 'granted') {
            getMessagingToken().then((currentToken) => {
                if (currentToken)
                    notifications.setToken(currentToken);
            }).catch(() => {})

        } else {
            storeNotificationsEnabled(false);
            notifications.setEnabled(false);
            document.getElementById('enable-notifications').checked = false;
        }
    }, [accountData, resetFlag]);

    useEffect(() => {
        let changesExist = !arraysEqual(getTopicSubscriptions(), notifications.subscriptions) || notifications.enabled !== getNotificationsEnabled();
        updateChangeFlags(2, changesExist);
    }, [notifications.subscriptions, notifications.enabled, notifications.savedFlag]);

    const handleNotificationEnabled = (value) => {
        if(value) {
            if(Notification.permission !== 'granted') {

                Notification.requestPermission().then((result) => {
                    if (result === 'granted')
                        enableNotificiations();
                    else {
                        disableNotifications();
                        document.getElementById('enable-notifications').checked = false;    
                    }            
                }).catch(err => console.log(err))

            } else 
                enableNotificiations();    
        } else
            disableNotifications();
    }
    const enableNotificiations = () => {
        notifications.setEnabled(true);

        getMessagingToken().then((currentToken) => {
            if (currentToken)
                notifications.setToken(currentToken);
        });
    }
    const disableNotifications = () => {
        notifications.setEnabled(false);
    }
    const updateSubscriptionToTopic = (active, topic) => {
        if(active) {
            if(!notifications.subscriptions.includes(topic)) {
                notifications.subscriptions.push(topic);
                notifications.setSubscriptions([...notifications.subscriptions]);
            }
        } else {
            if(notifications.subscriptions.includes(topic)) {
                notifications.subscriptions.splice(notifications.subscriptions.indexOf(topic), 1);
                notifications.setSubscriptions([...notifications.subscriptions]);
            }
        } 
    }

    return (
        <div id={styles.notifications} className={styles.category}>
            <h1>Notifications</h1>
            <p>Notification settings are device specific.<br/>Each device has it's own settings</p>
            <div className={styles.labeled_checkbox}>
                <input id='enable-notifications' type='checkbox' onChange={(e) => handleNotificationEnabled(e.target.checked)} defaultChecked={notifications.enabled}/>
                <label htmlFor='enable-notifications'>Enable Push Notifications</label>
            </div>
            {
                getAvailablePushNotifications(accountData?.account_type, accountData?.account_area, !notifications.enabled, updateSubscriptionToTopic, notifications.subscriptions)
            }
        </div>
    )
}
function ProfilePictureTab({accountData, updateChangeFlags, resetFlag, mouseDown, mouseCords, updateEditedAccountData}) {
    const [profilePic, updateProfilePic] = useState(accountData?.profile_pic);

    useEffect(() => {
        updateProfilePic(accountData?.profile_pic)
    }, [accountData, resetFlag])

    useEffect(() => {
        updateChangeFlags(3, profilePic !== accountData?.profile_pic);
        updateEditedAccountData({profile_pic: profilePic});
    }, [profilePic, accountData]);

    return (
        <div id={styles.profile} className={styles.category}>
            <h1>Profile Picture</h1>
            <ProfilePicEditor profilePic={profilePic} updateProfilePic={updateProfilePic} mouseCords={mouseCords} mouseDown={mouseDown} firstInitial={accountData?.first_name?.[0]}/>
        </div>
    )
}

function convertBirthDateToString(birth_date) {
    if(birth_date?.seconds !== undefined) {
        var date = new Date(birth_date?.seconds * 1_000);
        return date.toISOString().split('T')[0];
    }

    return "";
}
function parseBirthdayFromString(birthdate) {
    return new Timestamp(new Date(birthdate).getTime() / 1000 + 8*60*60, 0);
}

function useEditedAccountData() {
    const [, currentUserData] = useAuth();
    const [editedAccountData, setAccountData] = useState(currentUserData);

    useEffect(() => setAccountData(currentUserData), [currentUserData]);

    const updateAccountData = (data) => {
        var updated = {};
        for(const field in currentUserData)
            updated[field] = data?.[field] ?? editedAccountData?.[field] ?? currentUserData?.[field];

        setAccountData(updated);
    }

    return [editedAccountData, updateAccountData];
}
function useEditedNotificationSubscriptions() {
    const [token, setToken] = useState();
    const [enabled, setEnabled] = useState(getNotificationsEnabled);
    const [subscriptions, setSubscriptions] = useState(getTopicSubscriptions);
    const [savedFlag, setSavedFlag] = useState(0);

    const flagSaved = () => {setSavedFlag(savedFlag+1)}

    return {token, subscriptions, enabled, savedFlag, setToken, setSubscriptions, setEnabled, flagSaved};
}

function arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    a.sort();
    b.sort();

    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

function getAvailablePushNotifications(accountType, accountArea, disabled, updateSubscriptionToTopic, subscriptions) {
    var adminNotifications = (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <h3>Admin Push Notifications</h3>
            <div className={styles.labeled_checkbox}>
                <input id='new-account-requests' type='checkbox' disabled={disabled} defaultChecked={subscriptions.includes('admin-new-account-request')} 
                    onChange={(e) => updateSubscriptionToTopic(e.target.checked, 'admin-new-account-request')}/>
                <label htmlFor='new-account-requests'>New Account Requests</label>
            </div>
            <div className={styles.labeled_checkbox}>
                <input id='account-type-area-request' type='checkbox' disabled={disabled} defaultChecked={subscriptions.includes('admin-new-type-area-request')}
                    onChange={(e) => updateSubscriptionToTopic(e.target.checked, 'admin-new-type-area-request')}/>
                <label htmlFor='account-type-area-request'>New Account Type/Area Change Request</label>
            </div>
            
        </div>
    )

    var maintenanceNotifications = (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <h3>Maintenance Push Notifications</h3>
            <div className={styles.labeled_checkbox}>
                <input id='new-maintenance-requests' type='checkbox' disabled={disabled} defaultChecked={subscriptions.includes('maintenance-new-request')} 
                    onChange={(e) => updateSubscriptionToTopic(e.target.checked, 'maintenance-new-request')}/>
                <label htmlFor='new-maintenance-requests'>New Maintenance Requests</label>
            </div>
            <div className={styles.labeled_checkbox}>
                <input id='upcoming-recurring-maintenance-job' type='checkbox' disabled={disabled} defaultChecked={subscriptions.includes('maintenance-upcoming-recurring-job')} 
                    onChange={(e) => updateSubscriptionToTopic(e.target.checked, 'maintenance-upcoming-recurring-job')}/>
                <label htmlFor='upcoming-recurring-maintenance-job'>Upcoming Recurring Maintenance Job</label>
            </div>
            
        </div>
    )

    if(accountType === 'Chautauqua') {
        return (
            <div id={styles.notification_list}>
                { (accountArea === 'Administration' || accountArea === 'Development') ? adminNotifications : null }
                { (accountArea === 'Maintenance' || accountArea === 'Development') ? maintenanceNotifications : null }
            </div>
        )
    } else {
        return (
            <div id={styles.notification_list}>
                
            </div>
        )
    }

    
}

export default AccountSettings;